<template>
    <multiselect
        v-model="cnaes"
        :options="activeCnaes"
        track-by="uuid"
        label="activity"
        :custom-label="customLabel"
        :multiple="true"
        :allowEmpty="true"
        placeholder="Actividades CNAE"
        selectedLabel=""
        selectLabel=""
        deselectLabel=""
        @input="notifyChange"></multiselect>
</template>

<script>
    import Multiselect from 'vue-multiselect';
    import {mapGetters} from 'vuex';

    export default {
        name: "CnaeMultipleSelector",
        components: {
            Multiselect
        },
        props: {
            value: Array
        },
        data: function () {
            return {
                cnaes: []
            }
        },
        mounted() {
            this.$store.dispatch('loadCnaes');
            this.cnaes = this.evaluateValue(this.value);
        },
        computed: {
            ...mapGetters([
                'activeCnaes'
            ])
        },
        methods: {
            evaluateValue(value) {
                if (Array.isArray(value) && !!value.length) {
                    let array = [];
                    value.forEach((cnae) => {
                        if (
                            !!cnae
                            && !!cnae.uuid
                            && !!this.findCnaeByUuid(cnae.uuid)
                        ) {
                            array.push(this.findCnaeByUuid(cnae.uuid));
                        }
                    });
                    return array;
                } else {
                    return [];
                }
            },
            findCnaeByUuid(uuid) {
                return this.activeCnaes.find(cnae => (cnae.uuid === uuid));
            },
            notifyChange(cnae) {
                this.$emit('input', cnae);
            },
            customLabel ({ code, activity }) {
                return `${code} - ${activity}`
            }
        },
        watch: {
            value: function () {
                this.cnaes = this.evaluateValue(this.value);
            },
            activeCnaes: function () {
                this.cnaes = this.evaluateValue(this.value);
            }
        }
    }
</script>

<style scoped>

</style>